/*
    depreciate, will be remove in the future
*/
export default {
    name: 'TableEdit',

    functional: true,

    props: {
        row: Object,
        index: Number,
        cellEditing: Boolean,
        cellEditable: Boolean,
        column: {
            type: Object,
            default: null
        },
    },

    render: (h, ctx) => {
        var { row, column, index, cellEditing, cellEditable } = ctx.props,
            content = column.edit,
            options = column.options || {}

        const props = Object.assign({}, {
            row,
            column,
            index,
            cellEditing,
            cellEditable,
            optionList: options.optionList,
            render: options.render,
        })

        const attrs = Object.assign({}, options.props)

        return h(content, {
            props,
            attrs,
            on: options.on || {}
        })
    }
}